import * as Yup from 'yup';
import { EActivateServiceMode } from './types';

const URL_REGEXP = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

/** Read-only attributes of an already linked EM are sent as they are, so only the plan is checked. */
export const getValidationSchema = (mode: EActivateServiceMode) => {
	const subscriptionPlanId = Yup.number().required('Required');
	if (mode === EActivateServiceMode.EXISTING) return Yup.object().shape({ subscriptionPlanId });

	return Yup.object().shape({
		fullName: Yup.string().required('Required'),
		tinNumber: Yup.string().required('Required'),
		contactName: Yup.string().required('Required'),
		nominatedEmail: Yup.string().email('Invalid email').required('Required'),
		phone: Yup.string().required('Required'),
		registeredCountryId: Yup.number().required('Required'),
		registeredPostalCode: Yup.string().required('Required'),
		regAddressCity: Yup.string().required('Required'),
		regStreetNo: Yup.string().required('Required'),
		officialSiteUrl: Yup.string().matches(URL_REGEXP, 'Invalid URL').required('Required'),
		legalStatus: Yup.string().required('Required'),
		paymentHandlingMode: Yup.string().required('Required'),
		invoiceFeeTypeId: Yup.number().required('Required'),
		subscriptionPlanId,
		existingEmId:
			mode === EActivateServiceMode.ASSIGN
				? Yup.number().required('Select the existing EM account')
				: Yup.mixed().notRequired(),
	});
};
